import React, { useState, useEffect, useContext } from 'react';
// import '../assets/style.css';
// import '../assets/css/index.css';
// import '../assets/css/grid.css';
// import '../assets/css/theme.css';

// import '../assets/boxicons-2.0.7/css/boxicons.min.css';

import { Link } from 'react-router-dom';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import NewQuestionBox from '../NewQuestionBox';
import ImagewithTextField from '../ImagewithTextField';
import TexttoSpeechwithTextfield from '../TexttoSpeechwithTextfield';
import QuestionswithTextField from '../QuestionswithTextField';
import ImagewithRadio from '../ImagewithRadio';
import CorrectAnswers from '../CorrectAnswers';
import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json';
import Amplify, { Auth } from 'aws-amplify';
import config from '../../aws-exports';
import { UserContext } from '../UserContext';
import { useLocation } from 'react-router';
import { withAuthenticator } from 'aws-amplify-react';

import { default as animationData1 } from '../../assets/congratulations.json';
import { default as animationData2 } from '../../assets/tryagain.json';

import { cx } from '@emotion/css';
import { button } from '../../styles/components/buttons.style';
import * as styles from '../quizApp.style';

Amplify.configure(config);

function QuizApp(props) {
  const [questionBank, set_questionBank] = useState([]);
  const [score, set_score] = useState(0);
  const incrementScore = () => set_score(score + 1);
  const [noofquestionsattended, set_noquestionsattended] = useState(0);
  const [questionnumber, set_questionnumber] = useState(1);
  const [useranswer, set_useranswer] = useState('');
  const [totalquestions, set_totalquestions] = useState(0);
  const [finished, is_finished] = useState(false);
  const [imagewithtextfield, is_imagewithtextfield] = useState(false);
  const [imagewithradio, is_imagewithradio] = useState(false);
  const [questionwithradio, is_questionwithradio] = useState(false);
  const [questionwithtextfield, is_questionwithtextfield] = useState(false);
  const [texttospeechwithtextfield, is_texttospeechwithtextfield] =
    useState(false);

  //const [user_answers, set_user_answers] = useState([]);
  const [user_answers_right, set_user_answers_right] = useState({});
  const [user_answers_right1, set_user_answers_right1] = useState({});
  const [event_activity_answers, set_event_activity_answers] = useState({});
  const [real_answers, set_real_answers] = useState({});
  const [jwt_token, set_jwt_token] = useState({});
  const [presentquestion, set_presentquestion] = useState({
    answers: (4)[('Italy', 'Russia', 'USA', 'Germany')],
    attempts: 0,
    category: 'Sports',
    correctanswer: 'Russia',
    failures: 0,
    id: 0,
    level: 3,
    question: 'Which country hosted 2014 Winter Olympics?',
    specificcategory: 'Olympics',
    subcategory: 'Sports',
  });
  const { user } = useContext(UserContext);
  // const {user,setUser} = useContext(UserContext);
  let data1 = useLocation();
  // ////console.log("Calling EventsScreen.....")
  // ////console.log(data1.state)
  // const specificcategory = data1.state["specificcategory"]
  // const level1 = data1.state["level"]
  // const limits = data1["limits"]
  // const eventdisplay = data1["eventdisplay"]
  // ////console.log(specificcategory)
  // ////console.log(level1)
  // ////console.log(limits)
  // ////console.log(eventdisplay)
  let answ = [];

  function playAgainplease() {
    set_score(0);
    set_questionnumber(1);
    set_noquestionsattended(0);
    is_finished(false);
    getToken();
    set_real_answers({});
  }

  const getToken = async (id, level, category) => {
    Auth.currentSession().then((res) => {
      ////console.log(Auth.user.attributes.email)
      let accessToken = res.getAccessToken();
      let jwt = accessToken.getJwtToken();
      set_presentquestion({
        answers: (4)[('Italy', 'Russia', 'USA', 'Germany')],
        attempts: 0,
        category: 'Sports',
        correctanswer: 'Russia',
        failures: 0,
        id: 0,
        level: 3,
        question: 'Which country hosted 2014 Winter Olympics?',
        specificcategory: 'Olympics',
        subcategory: 'Sports',
      });
      getQuestionfromDB(jwt);
      set_jwt_token(jwt);
    });
  };

  const updateEventyActivity = async (jwt, updatedscore) => {
    var questionno;
    let eventanswermap = {};
    for (questionno in questionBank) {
      ////console.log(questionno)
      ////console.log(questionBank[questionno].question)
      var question;
      if (imagewithtextfield) {
        question =
          '<img src = ' +
          questionBank[questionno].question +
          ' height: 100px, width: 100px />';
      } else {
        question = questionBank[questionno].question;
      }
      answ[questionno] =
        'Q: ' +
        questionno +
        ' Question: ' +
        question +
        ' Correct Answer: ' +
        questionBank[questionno].correctanswer +
        ' Your selection: ' +
        user_answers_right[questionBank[questionno].id];

      eventanswermap[questionBank[questionno].correctanswer] =
        user_answers_right[questionBank[questionno].id];
    }

    set_event_activity_answers(eventanswermap);

    ////console.log(answ)

    ////console.log("Before updating event activity")
    ////console.log(eventanswermap)

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      // body: JSON.stringify({'question': id , 'tablename': category+"Questions",'level': level})
      body: JSON.stringify({
        eventid: data1.state['id'],
        username: user['username'],
        score: updatedscore,
        timetaken: 10,
        targetscore: data1.state['qualificationno'],
        level: data1.state['level'],
        operation: data1.state['name'],
        description: data1.state['name'],
        emailid: Auth.user.attributes.email,
        category: data1.state['category'],
        correctanswers: answ,
        emailtobesend: data1.state['sendEmail']
          ? data1.state['sendEmail']
          : false,
        eventemailid: data1.state['email']
          ? data1.state['email']
          : Auth.user.attributes.email,
        useranswers: eventanswermap,
      }),
    };
    ////console.log(requestOptions)

    const response = await fetch(
      `https://api.quizwizard.net/quiz/eventactivity`,
      requestOptions
    );
    const data = await response.json();
    ////console.log("After Event Activity")
    ////console.log(data)
  };

  const updateUserScore = async (jwt, updatedscore) => {
    let newscore = 0;
    if (updatedscore >= data1.state['qualificationno']) {
      newscore = user['score'] + data1.state['points'];
      user['score'] = newscore;
    } else {
      newscore = user['score'] - data1.state['points'];
      user['score'] = newscore;
    }

    const updateScoreOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({
        username: user['username'],
        score: newscore,
        appname: 'QuizWhiz',
        id: user['username'],
      }),
    };
    ////console.log(updateScoreOptions)
    ////console.log("score during updatescore options")
    ////console.log(score)
    const response = await fetch(
      `https://api.quizwizard.net/quiz/updatescore`,
      updateScoreOptions
    );
    const data = await response.json();
    ////console.log("After calling Update Score")
    ////console.log(data)
  };

  const getQuestionfromDB = async (jwt) => {
    const specificcategory = data1.state['specificcategory'];
    const level1 = data1.state['levels'];
    const limits = data1.state['limits'];
    const eventdisplay = data1.state['eventdisplay'];
  
    // Set display type flags
    if (eventdisplay === 'ImagewithTextField') {
      is_imagewithtextfield(true);
    } else if (eventdisplay === 'ImagewithRadio') {
      is_imagewithradio(true);
    } else if (eventdisplay === 'SpeakTextwithTextField') {
      is_texttospeechwithtextfield(true);
    } else if (eventdisplay === 'QuestionswithTextField') {
      is_questionwithtextfield(true);
    } else {
      is_questionwithradio(true);
    }
  
    const specificcategoryreplace = ('' + specificcategory).replace(/%20/g, ' ');
  
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({
        category: 'Mathematics',
        level: level1,
        levels: ('' + level1).split(',').map(Number),
        limits: ('' + limits).split(',').map(Number),
        name: 'Math1',
        noofretries: 1,
        points: 5,
        qualificationno: 9,
        subcategory: ['Addition'],
        specificcategory: ('' + specificcategoryreplace).split(','),
        time: 60,
        totalquestions: 10,
      }),
    };
  
    try {
      const response = await fetch(
        `https://api.quizwizard.net/quiz/getquestions`,
        requestOptions
      );
      const data = await response.json();
  
      if (data.length > 0) {
        set_questionBank(data);
        set_presentquestion(data[0]);
  
        let dict_answer = {};
        for (const question of data) {
          dict_answer[question.id] = question.correctanswer;
        }
        set_real_answers(dict_answer);
      } else {
        console.warn("No questions received from the API");
        set_questionBank([]);
        set_presentquestion(null); // Keep this, but ensure rendering handles it
        return;
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
      set_questionBank([]);
      set_presentquestion(null);
    }
  };

  function computeAnswer(answer, id) {
    ////console.log(answer)
    let useranswermap = user_answers_right;
    useranswermap[id] = answer;

    set_user_answers_right(useranswermap);
    //////console.log(user_answers_right)
  }

  const selectedanswers = () => {
    // if(answer == real_answers[id])
    // {
    //   set_score(score + 1)
    // }

    ////////console.log(user_answers)
    //noofquestionsattended = noofquestionsattended + 1

    if (noofquestionsattended + 1 < totalquestions) {
      set_questionnumber(questionnumber + 1);
      set_presentquestion(questionBank[noofquestionsattended + 1]);
      set_noquestionsattended(noofquestionsattended + 1);
      set_user_answers_right1(user_answers_right);
      //////console.log(noofquestionsattended)
    } else {
      //Lets update

      ////console.log("What user selected is ")
      ////console.log(user_answers_right)
      ////console.log("What real answer is  ")
      ////console.log(real_answers)
      let actualScore = 0;
      var key, val;
      for ([key, val] of Object.entries(user_answers_right)) {
        ////console.log(key, val);
        ////console.log(real_answers[key])
        if (real_answers[key] == val || real_answers[key] == 'Spell ' + val) {
          ////console.log("Correct Answer");
          actualScore = actualScore + 1;
          ////console.log(actualScore)

          set_score(actualScore);
          //set_score(10)
        }
      }
      is_finished(true);
      ////console.log("finsihed")
      ////console.log(finished)
      updateUserScore(jwt_token, actualScore);
      updateEventyActivity(jwt_token, actualScore);
    }

    // if(noofquestionsattended + 1  > totalquestions )
    // {
    //   is_finished(true)
    // }

    // set_presentquestion(questionBank[noofquestionsattended])
    //is_finished(true)
  };

  function backanswers() {
    // if(answer == real_answers[id])
    // {
    //   set_score(score + 1)
    // }

    ////////console.log(user_answers)
    //noofquestionsattended = noofquestionsattended + 1
    if (noofquestionsattended > 0) {
      set_questionnumber(questionnumber - 1);
      set_presentquestion(questionBank[noofquestionsattended - 1]);
      set_noquestionsattended(noofquestionsattended - 1);
      //////console.log(noofquestionsattended)
    } else {
      //Lets update
      // is_finished(true)
      // updateEventyActivity(jwt_token)
    }
    // if(noofquestionsattended + 1  > totalquestions )
    // {
    //   is_finished(true)
    // }

    // set_presentquestion(questionBank[noofquestionsattended])
    //is_finished(true)
  }

  function handleCallback(childData) {
    let actualScore = 0;
    var key, val;
    for ([key, val] of Object.entries(user_answers_right)) {
      if (real_answers[key] == val || real_answers[key] == 'Spell ' + val) {
        actualScore = actualScore + 1;
        set_score(actualScore);
      }
    }

    is_finished(true);
    updateUserScore(jwt_token, actualScore);
    updateEventyActivity(jwt_token, actualScore);
  }



  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const congratsOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const tryagainOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData2,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  useEffect(() => {
    // You need to restrict it at some point
    // This is just dummy code and should be replaced by actual
    let isMounted = true;
    ////console.log("UseEffect calling in QuizApp")
    getToken();
    document.title = 'Course Quiz';

    const totalquestions = data1.state['totalquestions'];
    set_totalquestions(totalquestions);
    return () => {
      isMounted = false;
    };
  }, []);

  const controlButtons = (
    <>
      {presentquestion && presentquestion?.id > 0 && finished == false ? (
        <div
          className={
            (questionwithtextfield || imagewithtextfield) &&
            cx(styles.buttonGroup)
          }
        >
          <button key="Back" onClick={backanswers}>
            Back
          </button>
          <button key="Next" onClick={selectedanswers}>
            Next
          </button>
        </div>
      ) : null}
    </>
  );

  return (
    <div>
      <div>
        <div
          className={`${finished ? 'no-shadow inner ' : ''}${cx(
            styles.container
          )}`}
        >
          {/* 
      Show only for Events */}
          {finished &&
            score < data1.state['qualificationno'] &&
            data1.state['eventtype'] != 'Assignments' ? (
            <div>
              <img
                className={cx(styles.img)}
                src={require('../../assets/images/icon-sad.jpeg').default}
                alt=""
              />
              <div className={`${cx(styles.title)} text-center`}>
                Score {score}/{data1.state['totalquestions']}
              </div>
              <img
                className={cx(styles.img)}
                src={require('../../assets/images/oops.jpeg').default}
                alt=""
              />
              <p className={`text-center color-black ${styles.title}`}>
                Try Again
              </p>
              {/* <div className={cx(styles.attempt)}>
                You have <span>{data1.state['remainingattempts'] - 1}</span>{' '}
                remaining attempts
              </div> */}
            </div>
          ) : (
            ''
          )}

          {/* 
      Show only for Events */}
          {finished &&
            score >= data1.state['qualificationno'] &&
            data1.state['eventtype'] != 'Assignments' ? (
            <div>
              <img
                className={cx(styles.img)}
                src={require('../../assets/images/happy.jpeg').default}
                alt=""
              />
              <div className={`${cx(styles.title)} text-center`}>
                Score {score}/{data1.state['totalquestions']}
              </div>
              <img
                className={cx(styles.img)}
                src={require('../../assets/images/congo.jpeg').default}
                alt=""
              />
              <p className={`text-center color-black ${styles.title}`}>
                You cleared the event
              </p>
            </div>
          ) : (
            ''
          )}

          {/* 
      Show only for Assignments */}
          {finished && data1.state['eventtype'] == 'Assignments' ? (
            <div>
              <img
                className={cx(styles.img)}
                src={require('../../assets/images/tick.jpeg').default}
                alt=""
              />
              <div className={`${cx(styles.title)} mb-0 text-center`}>
                Thanks
              </div>
              <p className={`text-center color-black ${styles.title}`}>
                Assignment Submitted
              </p>
            </div>
          ) : (
            ''
          )}

          {/* 
      Show only for all questions */}
          {presentquestion && presentquestion?.id > 0 && finished == false ? (
            <div className={styles.progress}>
              {questionBank.length > 0 ? (
                <>
                  <CountdownCircleTimer
                    isPlaying
                    duration={data1.state['time'] * data1.state['totalquestions']}
                    colors={['#eed017']}
                    size={105}
                    strokeWidth={7}
                    onComplete={handleCallback}
                  >
                    {({ remainingTime }) => {
                      const minutes = Math.floor(remainingTime / 60);
                      const seconds = remainingTime % 60;

                      return (
                        <div
                          className="text-center"
                          style={{ fontSize: '17px' }}
                        >
                          {minutes}:{seconds}
                          <br />
                          MIN
                        </div>
                      );
                    }}
                  </CountdownCircleTimer>
                  <p className="s-title">time remaining</p>
                </>
              ) : (
                ''
              )}{' '}
            </div>
          ) : presentquestion === null ? (
            <div style={{ textAlign: "center", marginTop: "2rem" }}>
                <h2>No questions found for this event.</h2>
                <p>Please check back later or try another category.</p>
            </div>
        ) : null}
{presentquestion && presentquestion?.id && !finished && imagewithradio ? (
  <ImagewithRadio
    question={presentquestion.question}
    answer={presentquestion.answers}
    imageurl={presentquestion.imageurl}
    id={presentquestion.id}
    key={presentquestion.id}
    selected={(answer) => computeAnswer(answer, presentquestion.id)}
    selectedanswer={user_answers_right[presentquestion.id]}
    subcategory={presentquestion.subcategory}
    questionnumber={questionnumber}
    questionCount={questionBank.length}
  />
) : null}

          {presentquestion && presentquestion?.id > 0 && finished == false && imagewithtextfield ? (
            <ImagewithTextField
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id]}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
              questionCount={questionBank.length}
            />
          ) : null}

          {finished && (
            <div>
              <div className={cx(styles.summary)}>
                <div className="item">
                  <p className="s-title">{totalquestions}</p>
                  <p className="sub-title">Question</p>
                </div>
                <div className="item">
                  <p style={{ color: '#2ec32b' }} className="s-title">
                    {score}
                  </p>
                  <p className="sub-title">Correct Answer</p>
                </div>
                <div className="item">
                  <p style={{ color: '#c32b2b' }} className="s-title">
                    {totalquestions - score}
                  </p>
                  <p className="sub-title">Wrong Answer</p>
                </div>
                <div className="item">
                  <p style={{ color: '#dd7029' }} className="s-title">
                    {Math.floor((score / totalquestions) * 100)}%
                  </p>
                  <p className="sub-title">Result</p>
                </div>
              </div>
            </div>
          )}

          {presentquestion && presentquestion?.id > 0 &&
            finished == false &&
            texttospeechwithtextfield ? (
            <TexttoSpeechwithTextfield
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id]}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
              nextbutton={selectedanswers}
            />
          ) : null}

{presentquestion && presentquestion?.id > 0 &&
  finished == false &&
  questionwithtextfield ? (
  <QuestionswithTextField
    question={presentquestion.question}
    answer={presentquestion.answers}
    id={presentquestion.id}
    key={presentquestion.id}
    selected={(answer) => computeAnswer(answer, presentquestion.id)}
    selectedanswer={user_answers_right[presentquestion.id]}
    subcategory={presentquestion.subcategory}
    questionnumber={questionnumber}
    nextbutton={selectedanswers}
    questionCount={questionBank.length}
  />
) : null}

{presentquestion && presentquestion?.id > 0 && finished == false && questionwithradio ? (
  <NewQuestionBox
    question={presentquestion.question}
    answer={presentquestion.answers}
    id={presentquestion?.id}
    questionnumber={questionnumber}
    key={presentquestion.id}
    selected={(answer) => computeAnswer(answer, presentquestion.id)}
    selectedanswer1={user_answers_right1[presentquestion.id]}
    category={data1.state['subcategory']}
    questionCount={questionBank.length}
    controlButtons={controlButtons}
  />
) : null}

          {!questionwithradio && controlButtons}

          {presentquestion?.id <= 0 ? (
            <div className="welcomecenter">
              <Lottie options={defaultOptions} height={400} width={400} />
            </div>
          ) : (
            ''
          )}

          <div className="table-responsive">
            {finished && data1.state['eventtype'] != 'Event' ? (
              <table
                border={0}
                cellPadding={0}
                cellSpacing={0}
                className={cx(styles.table)}
              >
                <tr>
                  <th>Question</th>
                  <th>Correct Answer</th>
                  <th>Your Answer</th>
                  <th>Result</th>
                </tr>
              </table>
            ) : (
              ''
            )}

            {finished && data1.state['eventtype'] == 'Curriculum' && (
              <table
                border={0}
                cellPadding={0}
                cellSpacing={0}
                className={cx(styles.table)}
                style={{ marginBottom: '30px' }}
              >
                {questionBank.map(
                  ({
                    question,
                    answers,
                    correctanswer,
                    id,
                    id_1,
                    selectedanswer,
                  }) => (
                    <CorrectAnswers
                      question={question}
                      correctanswer={correctanswer}
                      id={id}
                      key={id}
                      selectedanswer={user_answers_right[id]}
                      eventtype={data1.state['eventdisplay']}
                    />
                  )
                )}
              </table>
            )}
          </div>

          <div className={styles.btnGroup}>
            {finished &&
              score < data1.state['qualificationno'] &&
              data1.state['remainingattempts'] - 1 > 0 &&
              (questionwithradio || texttospeechwithtextfield) ? (
              <div className="text-center">
                <Link
                  to={{
                    pathname: '/courses',
                    state: { category: data1.state['category'] },
                  }}
                >
                  <button className={cx(button)}> Try Again </button>
                </Link>
              </div>
            ) : (
              ''
            )}

            {finished && data1.state['eventtype'] == 'Curriculum' ? (
              <div className="text-center">
                <Link
                  to={{
                    pathname: '/opencourses',
                    state: data1.state['category'],
                  }}
                >
                  <button className={cx(button)}> Next Course </button>
                </Link>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default withAuthenticator(QuizApp, false);
